import apiClient from '@/api/apiClient';
import type { SystemUser } from '@/types/user';
import type { PaginatedResponse } from '@/types/api';

export interface UserMembership {
  account_id: string;
  is_admin: boolean;
  role_id?: string;
}

export interface UserCreate {
  email: string;
  first_name: string;
  last_name: string;
  password?: string;
  memberships: UserMembership[];
}

export interface UserBulkUpdate {
  first_name: string;
  last_name: string;
  memberships: UserMembership[];
}

export interface SystemAdminUsersParams {
  page?: number;
  page_size?: number;
  search?: string;
  account_id?: string;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
}

export default {
  getUsers(params: SystemAdminUsersParams = {}): Promise<PaginatedResponse<SystemUser>> {
    return apiClient.get('/system-admin/users', { params: { ...params } });
  },
  createUser(data: UserCreate): Promise<SystemUser> {
    return apiClient.post('/system-admin/users', data);
  },
  bulkUpdateUser(userId: string, data: UserBulkUpdate): Promise<SystemUser> {
    return apiClient.put(`/system-admin/users/${userId}`, data);
  },
  deleteUser(userId: string): Promise<void> {
    return apiClient.delete(`/system-admin/users/${userId}`);
  },
  changePassword(userId: string, newPassword: string): Promise<any> {
    return apiClient.post(`/system-admin/users/${userId}/change-password`, { new_password: newPassword });
  },
  getRoles(accountId: string): Promise<any[]> {
    return apiClient.get(`/system-admin/accounts/${accountId}/account-roles`);
  },
};
